/**
 * 给每个子节点设置颜色
 * @param {nodePtr} particleObject 父节点指针
 * @param {array} colorSize color和size数组
 */
const changeColor = async (particleObject, colorSize) => {
  const nodeList = await player.Native.NodeProxy.getNodeChildren(particleObject)
  // const nodeList = await player.Native.NodeProxy.getNodeChildrenRecursion(particleObject)
  for (let i = 0; i < nodeList.length; i += 1) {
    const e = nodeList[i]
    // eslint-disable-next-line no-await-in-loop
    await player.Native.ParticleEffekseer.setStartColor(e.nodePtr, colorSize[i].startColor)
    // eslint-disable-next-line no-await-in-loop
    await player.Native.ParticleEffekseer.setEndColor(e.nodePtr, colorSize[i].endColor)
  }
}

/**
 * @description: 加载粒子动画
 * @param {*} baseData {节点指针：nodePtr，粒子动画类型：dynModel，设备包围盒：resPtr}
 * @param {*} dynForm 默认表单参数
 * @return {*}
 */

const loadParticle = async (baseData, dynForm) => {
  // 设置位置
  let tempPos = []
  if (dynForm.position.X) {
    tempPos = [dynForm.position.X, dynForm.position.Y, dynForm.position.Z]
  } else {
    // 粒子的默认位置在模型上方
    tempPos = [
      1 * baseData.resPtr.localAabb.min[0] + (baseData.resPtr.localAabb.max[0] - baseData.resPtr.localAabb.min[0]) * 0.5, // x坐标
      1 * baseData.resPtr.localAabb.min[1] + (baseData.resPtr.localAabb.max[1] - baseData.resPtr.localAabb.min[1]) * 0.5, // y坐标
      baseData.resPtr.localAabb.max[2], // z坐标
    ]
    console.log(tempPos, 'tempPos')
    dynForm.position = {
      X: tempPos[0],
      Y: tempPos[1],
      Z: tempPos[2],
    }
  }

  // 粒子默认缩放大小
  let tempProportion = []
  if (dynForm.proportion.X) {
    tempProportion = [dynForm.proportion.X, dynForm.proportion.Y, dynForm.proportion.Z]
  } else {
    tempProportion = [
      baseData.resPtr.localAabb.max[0] - baseData.resPtr.localAabb.min[0],
      baseData.resPtr.localAabb.max[1] - baseData.resPtr.localAabb.min[1],
      baseData.resPtr.localAabb.max[2] - baseData.resPtr.localAabb.min[2],
    ]
    if (dynForm.particleType === 'gas_diffusion') {
      tempProportion[0] *= 0.1
      tempProportion[1] *= 0.4
      tempProportion[2] *= 0.1
    } else if (dynForm.particleType === 'fire_normal') {
      tempProportion[0] *= 0.5
      tempProportion[1] *= 0.5
      tempProportion[2] *= 0.2
    } else if (['fire_fog', 'fire_large'].includes(dynForm.particleType)) {
      tempProportion[0] *= 0.1
      tempProportion[1] *= 0.4
      tempProportion[2] *= 0.1
    }
    dynForm.proportion = {
      X: tempProportion[0],
      Y: tempProportion[1],
      Z: tempProportion[2],
    }
  }

  // 角度
  let tempAngle = []
  if (dynForm.angle.X) {
    tempAngle = EulerAngle.toQuat([dynForm.angle.X, dynForm.angle.Y, dynForm.angle.Z])
  } else {
    // // 世界到节点的变换矩阵
    // const gTrans = await player.Native.NodeProxy.localTransform(baseData.nodePtr)
    // // 矩阵萃取的旋转四元数信息
    // tempAngle = Matrix4.decompose(Matrix4.multiply(gTrans, Matrix4.makeRotationAxis(90, [1.0, 0.0, 0.0]))).quaternion
    // const angle = EulerAngle.fromQuat(tempAngle)
    // console.log('angle', tempAngle, baseData)
    tempAngle = [0.707, 0.707, 0, 0]
    const angle = [90, 0, 0]
    dynForm.angle = {
      X: angle[0],
      Y: angle[1],
      Z: angle[2],
    }
  }
  const modelSetting = Wiz.globalSettings.globalConfig?.modelSetting || {}

  const isExists = await player.Native.File.exists(
    `data://../apps/${modelSetting.folderName}/digitalSimulation/dynamicModel/particle/${dynForm.particleType}`
  )
  // console.log(isExists, dynForm.particleType)
  if (isExists) {
    const url = `data://../apps/${modelSetting.folderName}/digitalSimulation/dynamicModel/particle/${dynForm.particleType}/${dynForm.particleType}.efk`
    // 创建粒子节点对象
    const particleObject = await player.Native.ParticleEffekseer.createParticle(url)
    // console.log(particleObject, 'particleObject')
    // 重新指定父节点
    await player.Native.NodeProxy.setNodeParent(particleObject, 0)

    await player.Native.NodeProxy.setLocalTranslation(particleObject, tempPos)
    await player.Native.NodeProxy.setLocalScaling(particleObject, tempProportion)
    await player.Native.NodeProxy.setLocalRotation(particleObject, tempAngle)
    if (dynForm.colorSize) {
      await changeColor(particleObject, dynForm.colorSize)
    }

    return { particleObject, dynForm }
  }
  return null
}

const destoryParticle = async (nodePtr) => {
  await player.Native.NodeProxy.destroyNode(nodePtr)
}
// mincoord 最小坐标
// maxcoord 最大坐标
// minValue 最小阈值
// maxValue 最大阈值
// curValue 当前测点值
const calcParticle = (mincoord, maxcoord, minValue, maxValue, curValue) => {
  if (curValue <= minValue) {
    curValue = minValue
  } else if (curValue >= maxValue) {
    curValue = maxValue
  }
  const curValueX = (maxcoord.X - mincoord.X) / (maxValue - minValue) * (curValue - minValue) + Number(mincoord.X)
  const curValueY = (maxcoord.Y - mincoord.Y) / (maxValue - minValue) * (curValue - minValue) + Number(mincoord.Y)
  const curValueZ = (maxcoord.Z - mincoord.Z) / (maxValue - minValue) * (curValue - minValue) + Number(mincoord.Z)

  return {
    curValueX, curValueY, curValueZ
  }
}

// mincoord 最小颜色
// maxcoord 最大颜色
// minValue 最小阈值
// maxValue 最大阈值
// curValue 当前测点值
const calcColor = (mincoord, maxcoord, minValue, maxValue, curValue) => {
  if (curValue <= minValue) {
    curValue = minValue
  } else if (curValue >= maxValue) {
    curValue = maxValue
  }
  const curValueColor = (maxcoord - mincoord) / (maxValue - minValue) * (curValue - minValue) + Number(mincoord)

  return curValueColor
}

export {
  loadParticle,
  destoryParticle,
  calcParticle,
  calcColor
}
